import { RouteObject } from "react-router";

import { convertRouteModule } from "../../../../lib/routing";

export const energyFlowRoutes: Array<RouteObject> = [
  {
    path: "*",
    lazy: async () => convertRouteModule(await import("./index")),
    children: [
      { path: ":medium?", lazy: async () => convertRouteModule(await import("./application")) },
    ],
  },
];
